import Vue from 'vue';
import Vuex from 'vuex';
import userStore from './modules/userStore.js';
import challengeStore from './modules/challengeStore.js';
import activityStore from './modules/activityStore.js';
import exerciseStore from './modules/exerciseStore.js';
import workoutStore from './modules/workoutStore.js';
import feedbackStore from './modules/feedbackStore.js';
import reportStore from './modules/reportStore.js';
import contentStore from './modules/contentStore.js';
import dashboardStore from './modules/dashboardStore.js';
import campaignStore from './modules/campaignStore.js';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'wotive',
  storage: window.sessionStorage,
  reload: 0,
})

export default new Vuex.Store({
  state: {
    menuExpanded: false,
    sideModal: false,
  },
  mutations: {
    expandMenu(state, payload) {
      state.menuExpanded = !state.menuExpanded;
    },
    
    toggleSideModal(state, payload) {
      state.sideModal = !state.sideModal;
    },
    
    updateReload(state) {
      state.reload++;
    }
  },
  actions: {
    reloadTable(context) {
      context.commit('updateReload');
    },
  },
  modules: {
    users: userStore,
    challenges: challengeStore,
    activity: activityStore,
    exercise: exerciseStore,
    feedback: feedbackStore,
    reports: reportStore,
    content: contentStore,
    dashboard: dashboardStore,
    campaigns: campaignStore,
    workouts: workoutStore,
  },
  plugins: [vuexLocalStorage.plugin]
});
